import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Navbar2 from "../components/navbar/Navbar2";

const HowToPlay = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 500,
      easing: "ease-in-sine",
      delay: 100,
    });
    AOS.refresh();
  }, []);

  const faqs = [
    {
      question: "መደብ ከመምረጦ በፊት Playing ውይም ሰከንድ ሚቆጥረው ምንድን ነው?",
      answer:
        "Playing ማልት ከጎኑ የሚያሳየውን የደራሽ መጠን ብር ያለው ጨዋታ እየተጫወቱ ያሉ አሉ ማለት ነው ስለዚህ እነሱ ከጨረሱ በኋላ ሰከንድ ጠብቆ በመግባት የደራሽ መጠንን ማስፋት ይቻላል።",
    },
    {
      question: "እንዴት ማሸነፍ እንችላለን?",
      answer:
        "የሚጠሩትን ቁጥሮች በእርስዎ ካርድ ላይ እየነኩ ሄደው አንድ መስመር ወይም 4ኮርነር ከሰሩ አሸናፊ ይሆናሉ።",
    },
    {
      question: "አንድ አሸናፊ ብቻ ነው የሚኖረው?",
      answer:
        "በ አንድ ጨዋታ ከአንድ በላይ አሸናፊ ሊኖር ይችላል ማለትም ከአንድ በላይ ሰዎች እኩል ሊዘጉ ይችላሉ ይህም ከሆነ የደራሽ መጠንን የሚካፈሉት ይሆናል።",
    },
  ];

  return (
    <>
      {/* NAVBAR */}
      <div className="fixed left-0 right-0 top-0 z-50 bg-gradient-to-l from-violet-900 via-violet-800 to-violet-900">
        <Navbar2 />
      </div>

      {/* BACKGROUND THEME */}
      <section className="min-h-screen bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#020617] text-white pt-24 pb-16 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl font-semibold mb-10 text-white font-serif">
            የተደጋጋሚ ጥያቄዎች (FAQ)
          </h1>

          {/* FAQ LIST */}
          <div className="space-y-5">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl shadow-lg transition-all duration-300"
                data-aos="fade-up"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex justify-between items-center px-6 py-4 text-left"
                >
                  <h2 className="font-semibold text-lg text-gray-100 font-serif">
                    {faq.question}
                  </h2>
                  <span
                    className={`p-2 rounded-full transition-all duration-300 ${
                      openIndex === index
                        ? "bg-gray-200 text-gray-800 rotate-45"
                        : "bg-blue-600 text-white"
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 6v12m6-6H6"
                      />
                    </svg>
                  </span>
                </button>

                {/* Answer Section */}
                {openIndex === index && (
                  <div
                    className="px-6 pb-5 text-sm text-gray-300 font-serif"
                    data-aos="fade-down"
                  >
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default HowToPlay;
